'use strict';

(function () {
  'use strict';

  angular.module('msSleep').controller('SleepEntryModalCtrl', SleepEntryModalCtrl);

  SleepEntryModalCtrl.$inject = ['close', '$log', 'STANDARD_DATE_FMT', 'eventTrackingSvc'];

  /* @ngInject */
  function SleepEntryModalCtrl(close, $log, STANDARD_DATE_FMT, eventTrackingSvc) {
    var today = moment().add(-1, 'day');
    var vm = this;
    vm.$onInit = activate;
    vm.day = today.format(STANDARD_DATE_FMT);
    vm.showCalendarOverlay = false;
    vm.showSummary = false;

    vm.closeModal = function (save) {
      close(save, 200);
    };
    vm.entryComplete = function (day, entryData) {
      eventTrackingSvc.fireEvent('sleepTool', 'diaryEntry', 'widget');
      vm.showSummary = true;
      vm.entry = entryData.entries[day];
    };
    vm.updateDay = function (day) {
      vm.day = day;
      vm.showCalendarOverlay = !vm.showCalendarOverlay;
    };

    ////////////////
    function activate() {
      $log.debug('SleepEntryModalCtrl activate');
    }
  }
})();